export default ['auto', 'hidden', 'visible', 'scroll'];
